import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'


Vue.use(Vuex);

const store = () => new Vuex.Store({
  state: {
    isLoading: false,
    selectedProducts: [],
    totalShipping: 0,
    showShoppingCartModal: false,
    showRouterOptionsModal: false,
    auth: null,
  },
  getters: {
    getIsLoading: state => state.isLoading,
    getSelectedProducts: state => state.selectedProducts,
    getTotalShipping: state => state.totalShipping,
    getShowShoppingCartModal: state => state.showShoppingCartModal,
    getShowRouterOptionsModal: state => state.showRouterOptionsModal,
    getAuth: state => state.auth,
  },
  mutations: {
    SET_SELECTED_PRODUCTS: function (state, selectedProducts) {
      state.selectedProducts = selectedProducts;
    },
    SET_TOTAL_SHIPPING: function (state, totalShipping) {
      state.totalShipping = totalShipping;
    },
    SET_IS_LOADING: function (state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_SHOW_SHOPPING_CART_MODAL: function (state, showShoppingCartModal) {
      state.showShoppingCartModal = showShoppingCartModal;
    },
    SET_SHOW_ROUTER_OPTIONS_MODAL: function (state, showRouterOptionsModal) {
      state.showRouterOptionsModal = showRouterOptionsModal;
    },
    SET_AUTH: function (state, auth) {
      state.auth = auth;
    },
  },
  plugins: [createPersistedState()]
});

export default store



// WEBPACK FOOTER //
// ./src/store.js